import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from './../../../environments/environment';
import { enpointCervinoWeb } from './../../configuration/enpointsCervino';
import { ItemFilterModel } from './../../models/filters/item-filter.model';
import { InvoicingModelModel } from '../../models/invoicing/invoicing-model.model';

@Injectable({
  providedIn: 'root'
})
export class InvoicingModelService {

  constructor(private _httpClient: HttpClient) { }

  createInvoicingModel(invoicingModelContract: InvoicingModelModel): Observable<InvoicingModelModel> {
    return this._httpClient.post<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.CreateInvoicingModel}`,
      invoicingModelContract);
  }

  createPurchaseModel(invoicingModelContract: InvoicingModelModel): Observable<InvoicingModelModel> {
    return this._httpClient.post<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.CreatePurchaseModel}`,
      invoicingModelContract);
  }

  copyInvoicingModel(idInvoicingModel: number): Observable<InvoicingModelModel> {
    return this._httpClient.post<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.CopyInvoicingModel}/${idInvoicingModel}`, null);
  }

  deleteInvoicingModel(invoicingModelId: number): Observable<InvoicingModelModel> {
    return this._httpClient.delete<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.DeleteInvoicingModel}/${invoicingModelId}`);
  }

  deletePurchaseModel(purchaseModelId: number): Observable<InvoicingModelModel> {
    return this._httpClient.delete<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.DeletePurchaseModel}/${purchaseModelId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportGeneralConsultationPurchaseModel(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.ExportGeneralConsultationPurchaseModel}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllInvoicingModelsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetAllInvoicingModelsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllPurchaseModelsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.GetAllPurchaseModelsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getInvoicingModelsForSelectionAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetInvoicingModelsForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getPurchaseModelsForSelectionAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.GetPurchaseModelsForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultationPurchaModel(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.GetColumnsForGeneralConsultationPurchaseModelAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetColumnsForGeneralConsultationAsync}`);
  }

  getColumnsInvoicingModel(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetColumnsInvoicingModelAsync}`);
  }

  getFirstInvoicingModelByKeysAsync(): Observable<InvoicingModelModel> {
    return this._httpClient.get<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetFirstInvoicingModelByKeysAsync}`);
  }

  getFirstPurchaseModelByKeysAsync(): Observable<InvoicingModelModel> {
    return this._httpClient.get<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.GetFirstPurchaseModelByKeysAsync}`);
  }

  getInvoicingModelByConsecutive(consecutive: number): Observable<InvoicingModelModel> {
    return this._httpClient.get<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetInvoicingModelByConsecutive}/${consecutive}`);
  }

  getPurchaseModelByConsecutive(consecutive: number): Observable<InvoicingModelModel> {
    return this._httpClient.get<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetInvoicingModelByConsecutive}/${consecutive}`);
  }

  getInvoicingModelById(invoicingModelId: number): Observable<InvoicingModelModel> {
    return this._httpClient.get<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetInvoicingModelById}/${invoicingModelId}`);
  }

  getPurchaseModelById(purchaseModelId: number): Observable<InvoicingModelModel> {
    return this._httpClient.get<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.GetPurchaseModelById}/${purchaseModelId}`);
  }

  getLastInvoicingModelByKeysAsync(): Observable<InvoicingModelModel> {
    return this._httpClient.get<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetLastInvoicingModelByKeysAsync}`);
  }

  getLastPurchaseModelByKeysAsync(): Observable<InvoicingModelModel> {
    return this._httpClient.get<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.GetLastPurchaseModelByKeysAsync}`);
  }

  getNextInvoicingModelByKeysAsync(consecutive: number): Observable<InvoicingModelModel> {
    const itemFilterResponse = new ItemFilterModel("consecutive", consecutive, null, "");
    return this._httpClient.post<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetNextInvoicingModelByKeysAsync}`, itemFilterResponse);
  }

  getNextPurchaseModelByKeysAsync(consecutive: number): Observable<InvoicingModelModel> {
    const itemFilterResponse = new ItemFilterModel("consecutive", consecutive, null, "");
    return this._httpClient.post<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.GetNextPurchaseModelByKeysAsync}`, itemFilterResponse);
  }

  getPreviusInvoicingModelByKeysAsync(consecutive: number): Observable<InvoicingModelModel> {
    const itemFilterResponse = new ItemFilterModel("consecutive", consecutive, null, "");
    return this._httpClient.post<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.GetPreviusInvoicingModelByKeysAsync}`, itemFilterResponse);
  }

  getPreviusPurchaseModelByKeysAsync(consecutive: number): Observable<InvoicingModelModel> {
    const itemFilterResponse = new ItemFilterModel("consecutive", consecutive, null, "");
    return this._httpClient.post<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.GetPreviusPurchaseModelByKeysAsync}`, itemFilterResponse);
  }

  updateInvoicingModel(invoicingModelContract: InvoicingModelModel): Observable<InvoicingModelModel> {
    return this._httpClient.put<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingModel.UpdateInvoicingModel}`,
      invoicingModelContract);
  }

  updatePurchaseModel(purchaseModelContract: InvoicingModelModel): Observable<InvoicingModelModel> {
    return this._httpClient.put<InvoicingModelModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseModel.UpdatePurchaseModel}`,
      purchaseModelContract);
  }
}